import { MoreVert, Favorite, FavoriteBorder, FiberManualRecord, RestoreOutlined, DeleteOutline} from '@material-ui/icons'
import Axios from 'axios'
import React, { useState, useEffect, useContext } from 'react'
import { format } from 'timeago.js'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'


import './trashedPost.css'
import { AuthContext } from '../../context/AuthContext'

//Dropdown Component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href="#"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
)); 

const Post = ({ post, onPostHide }) => {
    
    const [likes, setLikes] = useState(post.likes.length)
    const [user, setUser] = useState({})
    const {user: currentUser} = useContext(AuthContext)
    const [isLiked, setIsLiked] = useState(post.likes.includes(currentUser._id))
    

    const PF = process.env.REACT_APP_PUBLIC_FOLDER
    const API = process.env.REACT_APP_API_URL

    //Handle the click on save/unsave button
    const handleRestore = async () => {
        try {
            await Axios.patch(API + `posts/restore/${post._id}`, {userId : currentUser._id})
            onPostHide(post._id)
        } catch (error) {
            throw error
        }
    }
    //Handle the click on soft delete button
    const handleDeletePermanently = async () => {
        try {
            //Deleting the post from MongoDB
            await Axios.patch(API + `posts/delete/${post._id}`, {userId : currentUser._id})

            //Deleting the image from Firebase


            onPostHide(post._id)
        } catch (error) {
            throw error
        }
    }
    
    //Handle the click on the like button
    const handleLike = async () => {
        try {
            await Axios.put(API + `posts/like/${post._id}`, {userId : currentUser._id})
            setIsLiked((like) => !like)
            setLikes((likes) => isLiked ? likes-1 : likes+1)
        } catch (error) {
            throw error
        }
    }

    //Fetching the user info
    useEffect(() => {
        const fetchUser = async () => {
            const res = await Axios.get(API + `users/?userId=${post.userId}`)
            setUser(res.data.user)
        }
        fetchUser();
    }, [post, API])

    return (
        <div className="post">
            <div className="postWrapper">
                <div className="postTop">
                    <div className="postTopLeft">
                        <Link to={`profile/${user.username}`} style={{textDecoration: "none", color: "#111"}}>
                            <img src={user.profilePicture || (PF + "person/default_avatar.jpg")} className="postProfileImg" alt="" />
                            <span className="postUsername">{user.username}</span>
                        </Link>
                        <FiberManualRecord style={{fontSize: '7px'}}/>
                        <span className="postDate">{format(post.createdAt)}</span>
                    </div>
                    <div className="postTopRight">
                        <Dropdown className='dropdown-button' alignRight> 
                            <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                                <MoreVert style={{color: '#333'}}/>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                                {
                                    post.userId === currentUser._id &&
                                    <Dropdown.Item onClick={handleRestore}>
                                        <div className="">
                                            <RestoreOutlined style={{marginRight: '.75rem'}}/>
                                            Restore
                                        </div>
                                    </Dropdown.Item>
                                }
                                {
                                    post.userId === currentUser._id && 
                                    <Dropdown.Item onClick={handleDeletePermanently}>
                                        <DeleteOutline style={{marginRight: '.75rem'}}/>
                                        Delete Permanently
                                    </Dropdown.Item>
                                }
                            </Dropdown.Menu>  
                        </Dropdown>
                    </div>
                </div>
                <div className="postCenter">
                    <div className="postText">{post.description}</div>
                    {(post.hasOwnProperty('image') && post.image) && <img className="postImg" src={post.image} alt=""/>}   
                </div>
                <div className="postBottom">
                    <div className="postBottomLeft">
                        {isLiked ? <Favorite className="likeButton liked" onClick={handleLike}/> : <FavoriteBorder className="likeButton" onClick={handleLike}/>}
                        <span className="postLikeCounter">{likes} likes</span>
                    </div>
                    {/* <div className="postBottomRight">
                        <span className="postCommentCounter">8 comments</span>
                    </div> */}
                </div>
            </div>
            
        </div>
    )
}

export default Post
